export default "__VITE_ASSET__BWgdLBFr__"